export const GROUP_TITLE_LINK = 'title-link';
